import { useState } from 'react'
import AuthService from 'services/auth'
import InfiniteScroll from 'react-infinite-scroll-component'
import Member from './Member'
import AdminMemberDetailsModal from 'pages/Admin/Modals/MemberDetailsModal'
import CompanyMemberDetailsModal from 'pages/Company/Modals/MemberDetailsModal'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, SubTitle } from './styles'

export default function MemberList ({
  members = [],
  hasMore,
  totalMembers,
  onUpdate: handleUpdate,
  onScroll: handleScroll,
  ...props
}) {
  const [selectedMember, setSelectedMember] = useState (null)
  const [showMemberDetails, setShowMemberDetails] = useState (false)
  const userType = AuthService.getUserType ()

  const handleSelect = member => {
    setSelectedMember (member)
    setShowMemberDetails (true)
  }

  return (
    <Container>
      {!!totalMembers && (
        <SubTitle>
          {totalMembers + ' ' + (totalMembers === 1 ? 'Resultado' : 'Resultados')}
        </SubTitle>
      )}
      <InfiniteScroll
        dataLength={members.length}
        next={handleScroll}
        hasMore={hasMore}
        loader={<Loading/>}
        endMessage={<div style={{height: 50}}></div>}
        style={{overflow: 'visible'}}
        {...props}
      >
        {members.map (member => (
          <Member
            key={member.id}
            data={member}
            onSelect={handleSelect}
          />
        ))}
      </InfiniteScroll>
      {userType === 'admin' ? (
        <AdminMemberDetailsModal
          visible={showMemberDetails}
          data={selectedMember}
          onUpdate={handleUpdate}
          onClose={() => {
            setShowMemberDetails (false)
            setSelectedMember (null)
          }}
        />
      ) : (
        <CompanyMemberDetailsModal
          visible={showMemberDetails}
          data={selectedMember}
          onUpdate={handleUpdate}
          onClose={() => {
            setShowMemberDetails (false)
            setSelectedMember (null)
          }}
        />
      )}
    </Container>
  )
}
